//
// Site Search functions
//

const SITE_SEARCH_OPEN_BUTTON_CLASS = '.js-site-search-trigger';
const SITE_SEARCH_CLOSE_BUTTON_ID = '#js-site-search-close';
const SITE_SEARCH_DIALOG_ID = '#js-site-search';

export default class SiteSearch {
  constructor() {

    // Search elements
    this.siteSearchOpenTriggers = document.querySelectorAll(SITE_SEARCH_OPEN_BUTTON_CLASS);
    this.siteSearchCloseTrigger = document.querySelector(SITE_SEARCH_CLOSE_BUTTON_ID);
    this.siteSearchContainer = document.querySelector(SITE_SEARCH_DIALOG_ID);

    if (!this.siteSearchOpenTriggers) return;

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
  openSiteSearch() {
    this.siteSearchContainer.showModal();
  }

   /**
   * @public
   */
  closeSiteSearch() {
    this.siteSearchContainer.close();
  }

  /**
   * @public
   */
  addEventHandling() {
    // Open search buttons
    this.siteSearchOpenTriggers.forEach(siteSearchOpenTrigger => {
      siteSearchOpenTrigger.addEventListener('click', this.openSiteSearch.bind(this));
    });

    // Close search button
    this.siteSearchCloseTrigger.addEventListener('click', this.closeSiteSearch.bind(this));
  }
}